// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-1.8rem) translateX(0.15rem);
  background: white;
  color: rgba(var(--bs-body-color-rgb), 1);
}

.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown),
.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 1;
  background: none;
}

.container-input-diamond {
  transform: rotate(45deg);
  background: var(--light-gray-900);
  border: none;
  color: var(--color-black);
}
.container-input-diamond .input-diamond input {
  width: 56px;
  height: 56px;
  transform: rotate(-45deg);
  border: transparent;
  font-size: 45px;
  background: transparent;
  text-align: center;
  padding-top: 0px;
}
.container-input-diamond .input-diamond input:focus {
  outline: none;
}

.radioToggleButton {
  display: inline-grid;
}
.radioToggleButton input {
  visibility: hidden;
}
.radioToggleButton label {
  cursor: pointer;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding: 8px;
  border-radius: 8px;
  color: rgb(0, 92, 185);
  border: 2px solid rgb(218, 218, 218);
}
.radioToggleButton input:checked + label {
  background: var(--bg-toggle-btn-light-blue);
}

.dynamic-style-button {
  display: inline-grid;
}
.dynamic-style-button input {
  visibility: hidden;
}
.dynamic-style-button label {
  cursor: pointer;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  padding: 8px;
  border-radius: 8px;
  color: rgb(0, 74, 148);
  border: 2px solid rgb(218, 218, 218);
  border-color: rgb(0, 74, 148);
  font: 16px;
}
.dynamic-style-button input:checked + label {
  background: var(--bg-toggle-btn-light-blue);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/styles/input.scss"],"names":[],"mappings":"AAAA;;;;EAII,8DAAA;EACA,iBAAA;EACA,wCAAA;AACJ;;AAEA;;;;EAII,iBAAA;EACA,oBAAA;AACJ;;AAEA;;;EAGI,UAAA;EACA,gBAAA;AACJ;;AAEA;EACI,wBAAA;EACA,iCAAA;EACA,YAAA;EACA,yBAAA;AACJ;AAEQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AAAZ;AAEY;EACI,aAAA;AAAhB;;AAOA;EACI,oBAAA;AAJJ;AAMI;EACI,kBAAA;AAJR;AAOI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;AALR;AAQI;EACI,2CAAA;AANR;;AAUA;EACI,oBAAA;AAPJ;AASI;EACI,kBAAA;AAPR;AAUI;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,6BAAA;EACA,UAAA;AARR;AAWI;EACI,2CAAA;AATR;;AAaA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAVF;;AAaA,YAAA;AACA;EACE,0BAAA;AAVF","sourcesContent":[".form-floating>.form-control-plaintext~label,\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-select~label {\n    transform: scale(.85) translateY(-1.8rem) translateX(.15rem);\n    background: white;\n    color: rgba(var(--bs-body-color-rgb), 1);\n}\n\n.form-floating>.form-control-plaintext:focus,\n.form-floating>.form-control-plaintext:not(:placeholder-shown),\n.form-floating>.form-control:focus,\n.form-floating>.form-control:not(:placeholder-shown) {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n}\n\n.form-floating>.form-control:focus~label,\n.form-floating>.form-control:not(:placeholder-shown)~label,\n.form-floating>.form-select~label {\n    opacity: 1;\n    background: none;\n}\n\n.container-input-diamond {\n    transform: rotate(45deg);\n    background: var(--light-gray-900);\n    border: none;\n    color: var(--color-black);\n\n    .input-diamond {\n        input {\n            width: 56px;\n            height: 56px;\n            transform: rotate(-45deg);\n            border: transparent;\n            font-size: 45px;\n            background: transparent;\n            text-align: center;\n            padding-top: 0px;\n\n            &:focus {\n                outline: none;\n            }\n        }\n\n    }\n}\n\n.radioToggleButton {\n    display: inline-grid;\n\n    input {\n        visibility: hidden;\n    }\n\n    label {\n        cursor: pointer;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 20px;\n        padding: 8px;\n        border-radius: 8px;\n        color: rgb(0, 92, 185);\n        border: 2px solid rgb(218, 218, 218);\n    }\n\n    input:checked+label {\n        background: var(--bg-toggle-btn-light-blue);\n    }\n}\n\n.dynamic-style-button {\n    display: inline-grid;\n\n    input {\n        visibility: hidden;\n    }\n\n    label {\n        cursor: pointer;\n        font-weight: 700;\n        font-size: 16px;\n        line-height: 20px;\n        padding: 8px;\n        border-radius: 8px;\n        color: rgb(0, 74, 148);\n        border: 2px solid rgb(218, 218, 218);\n        border-color: rgb(0, 74, 148);\n        font: 16px;\n    }\n\n    input:checked+label {\n        background: var(--bg-toggle-btn-light-blue);\n    }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
